import * as React from 'react';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = () => ({
  container: {
    margin: '16px 0 16px',
    padding: '16px',
    width: '100%',
  },
  caption: {
    marginBottom: '4px',
  },
});

type Props = {
  classes: Record<string, any>;
  title?: string | null;
  caption?: React.ReactNode | string | null;
  children: React.ReactNode;
  headerActions?: React.ReactNode;
};

class SettingSectionComponent extends React.PureComponent<Props> {
  static defaultProps = {
    headerActions: null,
  };

  render() {
    const { classes, title, caption, children, headerActions } = this.props;
    return (
      <Paper className={classes.container}>
        <Grid container justifyContent="space-between">
          <Grid item xs={headerActions ? 7 : 12}>
            <Typography variant="h6">{title}</Typography>
            {caption && (
              <Typography variant="caption" className={classes.caption}>
                {caption}
              </Typography>
            )}
          </Grid>
          {headerActions && (
            <Grid item xs={5}>
              {headerActions}
            </Grid>
          )}
        </Grid>
        {children}
      </Paper>
    );
  }
}

export const SettingSection = withStyles(styles)(SettingSectionComponent);
